import { createStore } from 'redux-dynamic-modules';
import { getSagaExtension } from 'redux-dynamic-modules-saga';

import { getSnackbarModule } from '@/features/Snackbar/Snackbar.module';

import { getCommonDataModule } from './commonData/CommonData.module';
import { getUserModule } from './user/User.module';

export const store = createStore(
  {
    enhancers: [],
    extensions: [getSagaExtension({})],
    initialState: {},
  },
  getSnackbarModule(),
  getCommonDataModule(),
  getUserModule()
);
